import { render, staticRenderFns } from "./manageNptSettings.vue?vue&type=template&id=3085dbec"
import script from "./manageNptSettings.vue?vue&type=script&lang=ts"
export * from "./manageNptSettings.vue?vue&type=script&lang=ts"
import style0 from "./manageNptSettings.vue?vue&type=style&index=0&id=3085dbec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports